// src/utils/notificationService.js
/**
 * Serviço de notificações - Camada de compatibilidade
 * Redireciona para o novo sistema de notificações
 */

import {
    requestNotificationPermission as requestPerm,
    canReceiveNotifications,
    sendModuleNotification,
    sendNewTicketNotification as sendTicket,
    sendFollowUpNotification as sendFollow,
    sendTicketClosedNotification as sendClosed,
    sendTicketAssignedNotification as sendAssigned,
    sendFinanceNotification as sendFinance,
    sendInventoryNotification as sendInventory,
    sendChatNotification as sendChat
} from '../utils/browserNotifications';

// Re-exportar funções principais
export const requestNotificationPermission = requestPerm;

export const areNotificationsSupported = () => {
    return 'Notification' in window;
};

export const getNotificationPermission = () => {
    if (!('Notification' in window)) {
        return 'unsupported';
    }
    return Notification.permission;
};

// Função principal de envio (compatível com a antiga)
export const sendPushNotification = async (title, body, data = {}) => {
    if (!('Notification' in window)) {
        return false;
    }

    if (Notification.permission !== 'granted') {
        const granted = await requestPerm();
        if (!granted) return false;
    }

    try {
        // Não mostrar se a página está visível
        if (document.visibilityState === 'visible') {
            return false;
        }

        const module = data.module || 'helpdesk';
        const route = data.route || '/';

        const notification = sendModuleNotification(
            module,
            title,
            body,
            {
                route: route,
                tag: data.messageId || `notification_${Date.now()}`,
                data: data,
                requireInteraction: true,
                autoClose: 8000
            }
        );

        return notification !== null;
    } catch (err) {
        console.error('Error sending notification:', err);
        return false;
    }
};

// Exportar funções específicas
export const sendNewTicketNotification = sendTicket;
export const sendFollowUpNotification = sendFollow;
export const sendTicketClosedNotification = sendClosed;
export const sendTicketAssignedNotification = sendAssigned;
export const sendFinanceNotification = sendFinance;
export const sendInventoryNotification = sendInventory;
export const sendChatNotification = sendChat;

// Exportar utilitários
export default {
    requestNotificationPermission,
    sendPushNotification,
    sendNewTicketNotification,
    sendFollowUpNotification,
    sendTicketClosedNotification,
    sendTicketAssignedNotification,
    sendFinanceNotification,
    sendInventoryNotification,
    sendChatNotification,
    areNotificationsSupported,
    getNotificationPermission,
    canReceiveNotifications
};